import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DialogActions from "@mui/material/DialogActions";
import { DARK_THEME_BODY_COLOR } from "../../constants";

const ThemedDialogActions = ({ sx, children }) => {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);

  return (
    <DialogActions
      sx={{
        ...sx,
        backgroundColor: darkThemeEnabled ? DARK_THEME_BODY_COLOR : "#f7f7f7",
      }}
    >
      {children}
    </DialogActions>
  );
};

export default ThemedDialogActions;
